<template>
  <div class="match-bet text-center">
    <div v-if="matchBet.outcomes">
      <span
        v-if="specialValueAlt"
        class="bet-special-alt flex-center">
        {{ specialValueAlt }}
      </span>
      <div :class="{ 'has-special-alt-value': specialValueAlt }">
        <match-bet-outcome
          class="match-outcome flex-center"
          :class="[
            `outcome-${outcomes.length}`,
            {'increased-odd-size': increaseOddSize }]"
          v-for="(outcome, index) in outcomes"
          :key="index"
          :outcome="outcome"
        />
      </div>
    </div>
    <span v-else>
      -
    </span>
  </div>
</template>

<script>
import { take } from 'lodash';
import MatchBetOutcome from './MatchBetOutcome.vue';
import { specialreplace } from '@/filters/specialreplace';

export default {
  name: 'MatchBet',
  props: {
    matchBet: {
      required: true,
      type: Object,
    },
    matchRowTemplate: {
      default: '',
      required: false,
      type: String,
    },
    increaseOddSize: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  components: { MatchBetOutcome },
  data() {
    return {
      maxOutcomes: 3,
      maxOutcomesSpecial: 2,
      specialValueDisplayRules: {
        limitedDisplayTemplates: [
          'Medium',
          'Special',
          'SpecialPlus',
        ],
        excludedMatchRowTemplates: [
          'Standard',
        ],
        maxValuesPerLimitedTemplate: 1,
      },
      specialValueAlt: '',
    };
  },
  methods: {
    specialValueInline(rules, sv) {
      if (!rules) return sv;
      const specialValue = specialreplace(
        rules.specialValuesOrder.join(' '),
        sv,
      ).split(' ');
      const [specialValueAlt, specialValueGeneral] = specialValue;

      if (!this.unallowedSpecialValueType) this.specialValueAlt = specialValueAlt;
      return specialValueGeneral;
    },
  },
  computed: {
    unallowedSpecialValueType() {
      return this.matchBet.special.split('|').length > this.specialValueDisplayRules.maxValuesPerLimitedTemplate
        && this.specialValueDisplayRules.limitedDisplayTemplates
          .includes(this.$router.currentRoute.name)
        && !this.specialValueDisplayRules.excludedMatchRowTemplates
          .includes(this.matchRowTemplate);
    },
    specialMarket() {
      return this.$store.getters.specialMarkets.includes(this.matchBet.idBet);
    },
    singleSpecialValue() {
      return (this.matchBet.special || []).split('|').length < 2;
    },
    outcomes() {
      if (!this.matchBet.special) {
        return take(this.matchBet.outcomes, this.maxOutcomes);
      }

      const sportId = this.matchBet.idBet.split('/').pop();
      const bet = this.$store.getters.getSportBet(this.matchBet.idBet, sportId);

      // Use special value only for 2 outcomes ()
      const outcomesWithSpecial = take(this.matchBet.outcomes, this.maxOutcomes).slice();
      const shouldDisplaySpecialValue = (this.matchRowTemplate === 'Standard' || this.specialMarket || this.singleSpecialValue);

      if (this.matchBet.outcomes.length === 2 && shouldDisplaySpecialValue) {
        const specialValue = this.matchBet.special || '';
        outcomesWithSpecial.splice(1, 0, {
          valueSpecial: bet.specialValueDisplayRules
            ? this.specialValueInline(bet.specialValueDisplayRules, specialValue)
            : specialValue,
          specialValueDisplayRules: bet.specialValueDisplayRules,
        });
      }

      return outcomesWithSpecial;
    },

  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-bet {
  position: relative;
  float: left;
  height: 100%;
  width: 20%;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: $match-bet-vertical-line-width;
    background-color: $match-bet-vertical-line-color-back;
    z-index: 10;
  }
  .has-special-alt-value{
    margin: 0 .3rem 0 1rem;
  }
}

.match-outcome {
  position: relative;
  float: left;
  width: 50%;
  height: 100%;

  &.outcome-3 { width: 33.33% !important; }

  &.increased-odd-size {
    font-size: 1.125rem;
  }
}
.bet-special-alt {
  float: left;
  position: absolute;
  background: rgba(0,0,0, 0.4);
  width: .75rem;
  height: .8125rem;
  color: $color-important-special-alt;
  font-size: .625rem;
  border-radius: .25rem;
  margin: .0625rem;
}
</style>
